// Get Repair Time Guides

export const GET_REPAIR_TIME_GUIDES_REQUEST = 'GET_REPAIR_TIME_GUIDES_REQUEST';
export const GET_REPAIR_TIME_GUIDES_SUCCESS = 'GET_REPAIR_TIME_GUIDES_SUCCESS';
export const GET_REPAIR_TIME_GUIDES_FAIL = 'GET_REPAIR_TIME_GUIDES_FAIL';
export const CLEAR_REPAIR_TIME_GUIDES_STATE = 'CLEAR_REPAIR_TIME_GUIDES_STATE';
